import { useTranslation } from 'react-i18next';
import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { usePsiModel } from "../psiModel";

export const DataBox = () => {
    const { exportPsi, descTotal } = usePsiModel();
    const { t } = useTranslation();
    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                exportPsi()
            }}
        >
            {t(`stock.view.DataBox.导出`)}
        </Button>
    </>;
    const desc = [

        {
            label: t(`stock.view.DataBox.库存差异数量`),
            value: descTotal.differenceNumTotal,
            color: descTotal.differenceNumTotal != 0 ? "green" : "red",
            animation: descTotal.differenceNumTotal != 0
        },
        {
            label: t(`stock.view.DataBox.占用差异数量`),
            value: descTotal.occupyDifferenceTotal,
            color: descTotal.occupyDifferenceTotal != 0 ? "green" : "red",
            animation: descTotal.occupyDifferenceTotal != 0
        },
        {
            label: t(`stock.view.DataBox.库存数量`),
            value: descTotal.currentNumTotal ?? 0,
            color: "red"
        },
    ]
    return (
        <YhBox title={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}